import {
  headingsPlugin,
  linkPlugin,
  listsPlugin,
  MDXEditor,
  MDXEditorMethods,
  MDXEditorProps,
  quotePlugin,
  thematicBreakPlugin,
} from '@mdxeditor/editor';
import { useTheme } from '@mui/material';
import { forwardRef } from 'react';
import { StyledMarkdownContent } from './styles';
import { EditorGlobalStyles } from './globalStyles';
import '@mdxeditor/editor/style.css';

const MarkdownBase = forwardRef<MDXEditorMethods, MDXEditorProps>(
  (props, ref) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const { markdown = '', plugins = [], ...rest } = props;

    return (
      <StyledMarkdownContent>
        <EditorGlobalStyles />
        <MDXEditor
          ref={ref}
          className={isDark ? 'darkThemeStyles' : 'lightThemeStyles'}
          plugins={[
            headingsPlugin(),
            quotePlugin(),
            listsPlugin(),
            linkPlugin(),
            thematicBreakPlugin(),
            ...plugins,
          ]}
          markdown={markdown}
          {...rest}
        />
      </StyledMarkdownContent>
    );
  },
);

MarkdownBase.displayName = 'MarkdownBase';
export default MarkdownBase;
